<template>
  <div class="account tableStyle">
    <el-row>
      <el-col :span="24">
        <query
          :formData="formData"
          :formList="formList"
          @reset="resetQuery"
          @query="query"
          @clear="query"
        ></query>
      </el-col>
    </el-row>

    <el-row>
      <el-col :span="24">
        <el-button type="primary" size="small" @click="goAdd">新增运营账号</el-button>
      </el-col>
    </el-row>

    <div class="tableArea">
      <el-table :data="tableData" class="table-border" height="100%">
        <el-table-column
          type="index"
          label="序号"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="name"
          label="账号名称"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="mobile"
          label="手机号"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="created_at"
          label="创建时间"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="updated_at"
          label="最后登录时间"
          align="center"
        ></el-table-column>
        <el-table-column prop="status" label="状态" align="center">
          <template slot-scope="scope">
            <el-switch
              v-model="scope.row.status === 1"
              @change="changeStatus(scope.row)"
            ></el-switch>
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center">
          <template slot-scope="scope">
            <el-button type="primary" plain size="mini" @click="goReset(scope.row)">
              重置密码
            </el-button>
            <el-button type="danger" plain size="mini" @click="del(scope.row)">
              删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <!-- <el-row class="pageFoot">
      <el-col :span="24">
        
      </el-col>
    </el-row> -->
    <div class="pageFoot">
      <div class="tongji">
        统计：共{{total}}个
      </div>
      <el-pagination
        layout="total, prev, pager, next, sizes"
        background
        :page-size="size"
        :total="total"
        :page-sizes="[20,50,100,200,500,1000]"
        @size-change="sizeChange"
        @current-change="changePage"
      >
      </el-pagination>
    </div>

    <el-dialog
      title="新增运营账号"
      width="30%"
      custom-class="dialogRadius"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :visible.sync="dialogVisible"
      :before-close="closeAdd">
      <el-form :model="addForm" :rules="rules" ref="addForm" label-width="auto">
        <el-form-item label="用户名：" prop="name">
          <el-input v-model="addForm.name" placeholder="请输入用户名"></el-input>
        </el-form-item>
        <el-form-item label="手机号：" prop="mobile">
          <el-input v-model="addForm.mobile" placeholder="请输入手机号" onkeyup="this.value=this.value.replace(/[^\0-9]/g, '')" maxlength="11"></el-input>
        </el-form-item>
        <el-form-item class="tipsBox">
          <span class="tips">初始密码为手机号后6位</span>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeAdd">取 消</el-button>
        <el-button size="small" type="primary" @click="submit">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import Query from "components/query.vue";
export default {
  data() {
    return {
      size: 20,
      page: 1,
      total: 0,
      formData: {
        name: "",
        mobile: "",
      },
      formList: [
        {
          type: "input",
          label: "账号名称",
          placeholder: "请输入账号名称",
          model: "name",
        },
        {
          type: "input",
          label: "手机号",
          placeholder: "请输入手机号",
          model: "mobile",
        },
      ],
      tableData: [],
      dialogVisible: false,
      addForm:{
        name: '',
        mobile: '',
      },
      rules: {
        mobile: [
          {required: true, message: '请输入手机号码', trigger: 'blur'},
          { min: 11, max: 11, message: "请输入11位手机号", trigger: "blur" },
        ],
        name: [
          {required: true, message: '请输入用户名', trigger: 'blur'},
        ],
      },

      resetDialog: false,
      resetForm: {
        password: '',
      }
    };
  },
  components: {
    Query,
  },
  created() {
    this.init();
  },
  methods: {
    // 初始化
    init(data) {
      let params = {};
      if (data) {
        params = data;
      }
      params.page = this.page;
      params.size = this.size;
      this.$http
        .get(this.common.admin + "/admin/adminList", {
          params: params,
        })
        .then((res) => {
          if (res.code === 200) {
            this.total = res.data.total;
            this.tableData = res.data.list;
          } else {
            this.$message.error(res.msg);
          }
        });
    },
    // 查询
    query(data) {
      this.page = 1;
      this.init(data);
    },
    // 重置查询条件
    resetQuery() {
      this.page = 1;
      this.formData = {
        name: "",
        mobile: "",
      };
      this.init();
    },
    // 打开新建弹窗
    goAdd(){
      this.dialogVisible = true;
    },
    // 关闭新建弹窗
    closeAdd(){
      this.dialogVisible = false;
      this.addForm = {
        name: '',
        mobile: '',
      };
      this.$nextTick(() => {
        this.$refs.addForm.clearValidate();
      });
    },
    // 确认新建账号
    submit(){
      this.$refs.addForm.validate(v => {
        if(v === true){
          this.$http.post(this.common.admin + '/admin/addAdmin', this.addForm).then(res => {
            if(res.code === 200){
              this.$message.success('账号新建成功');
              this.closeAdd();
              this.page = 1;
              this.init();
            }
          });
        }else{
          this.$message.error('请将信息填写完整');
        }
      });
    },
    // 翻页
    changePage(page) {
      this.page = page;
      this.init();
    },
    sizeChange(val){
      this.size = val;
      this.init();
    },
    // 修改账号状态
    changeStatus(data) {
      this.$confirm(data.status === 1 ? '是否确定关闭该账号？' : '是否要开启该账号？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$http.post(this.common.admin + '/admin/changeAdminStatus', {id: data.id}).then(res => {
          if(res.code === 200){
            this.$message.success('操作成功');
            this.init();
          }else{
            this.$message.error(res.msg);
          }
        });
      }).catch(() => {
                 
      });
    },
    // 重置密码
    goReset(data) {
      this.$confirm(`是否确定重置 ${data.name} 的密码？`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let params = {
          id: data.id,
          password: this.getOriginalPwd(data.mobile)
        };
        this.$http.get(this.common.admin + '/admin/resetAdminPassword', {
          params: params
        }).then(res => {
          if(res.code === 200){
            this.$message.success('重置成功！密码已重置为手机号后6位');
          }else{
            this.$message.error(res.msg);
          }
        });
      }).catch(() => {
                 
      });
      
      // this.resetDialog = true;
      // this.resetForm.id = data.id;
    },
    // 获取手机号码后6位
    getOriginalPwd(phone){
      return phone.slice(5);
    },
    // 删除账号
    del(data) {
      this.$confirm(`是否确定删除 ${data.name} 的账号？`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let params = {
          id: data.id,
        };
        this.$http.get(this.common.admin + '/admin/deleteAdmin', {
          params: params
        }).then(res => {
          if(res.code === 200){
            this.$message.success('删除成功！');
            this.init();
          }else{
            this.$message.error(res.msg);
          }
        });
      }).catch(() => {
                 
      });
    },
  },
};
</script>
<style lang="less" scoped>
.account {
  height: 100%;
  display: flex;
  flex-direction: column;
  .tableArea{
    flex: 1;
    min-height: calc(100% - 184px);
  }
  .dialogRadius{
    .tipsBox{
      /deep/.el-form-item__content{
        line-height: 1;
        .tips{
          font-size: 14px;
          color: #c0c4cc;
        }
      }
    }
  }
  .pageFoot{
    display: flex;
    justify-content: space-between;
    align-items: center;
    .tongji{
      font-size: 14px;
    }
  }
}
</style>